class FacebookPostsHelper {
  selectedPostsIds() {
    const checked = $('.container-selected-posts .facebook-post-checkbox:checked')
    return _.map(checked, c => $(c).closest('tr').data('facebook-post-id'))
  }
}

export default FacebookPostsHelper
